<template>
  <div>
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员信息管理 -- 查看会员</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.Unbinding"
          @click="UnbindingBin"
          v-show="showButton === ''"
          >解绑微信</el-button
        >
        <el-button
          v-if="jurisdiction.change"
          @click="CardUpdate"
          v-show="showButton === ''"
          >卡号变更</el-button
        >
        <el-button
          v-if="jurisdiction.transfer"
          @click="MemberTransfer"
          v-show="showButton === ''"
          >会员转店</el-button
        >
        <el-button
          v-if="jurisdiction.adviser"
          @click="ButTurnBrandConsultant"
          v-show="showButton === ''"
          >会员转品牌顾问</el-button
        >
        <el-button
          v-if="jurisdiction.level"
          @click="GradeAdjustment"
          v-show="showButton === ''"
          >消费等级调整</el-button
        >
        <el-button
          v-if="jurisdiction.relationship"
          @click="goToMembershipBinding"
          v-show="showButton === ''"
          >会员关系绑定</el-button
        >
        <el-button
          v-if="jurisdiction.frozen"
          @click="Forzen"
          v-show="showButton === ''"
          >冻结/解冻</el-button
        >
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <!-- 卡号变更弹窗 -->
    <div class="alteration">
      <el-dialog
        width="25%"
        title="会员信息管理——卡号变更"
        :close-on-click-modal="false"
        :visible.sync="alterationFormVisible"
      >
        <el-form
          size="mini"
          ref="CardNumberChanges"
          :rules="cardFormRules"
          :label-position="labelPosition"
          label-width="100px"
          :model="cardForm"
        >
          <el-form-item label="客户姓名">
            <el-input v-model="cardForm.UserName" readonly></el-input>
          </el-form-item>
          <el-form-item label="移动电话">
            <el-input v-model="cardForm.Phpone" readonly></el-input>
          </el-form-item>
          <el-form-item label="会员等级">
            <el-input v-model="cardForm.Grade" readonly></el-input>
          </el-form-item>

          <el-form-item label="会员卡号">
            <el-input v-model="cardForm.OldCardNumber" readonly></el-input>
          </el-form-item>
          <el-form-item label="新卡号" prop="NewCardNumber">
            <el-input v-model="cardForm.NewCardNumber"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="CardNumberChange">确 定</el-button>
          <el-button @click="alterationFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 会员转店弹窗 -->
    <div class="shop">
      <el-dialog
        width="25%"
        :close-on-click-modal="false"
        title="会员转店\品牌顾问——转店\品牌顾问申请"
        :visible.sync="shopFormVisible"
      >
        <el-form
          :rules="formLabelAlignRules"
          size="mini"
          :label-position="labelPosition"
          label-width="150px"
          :model="formLabelAlign"
          ref="ButTransferShopRefs"
        >
          <el-form-item label="目标区域" prop="regionSelect">
            <el-select
              style="width: 100%"
              v-model="formLabelAlign.regionSelect"
              @change="RGetShopSelectList"
            >
              <el-option
                v-for="item in formLabelAlign.region"
                :key="item.id"
                :label="item.lable"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目标店铺" prop="StoreNameSelect">
            <el-select
              style="width: 100%"
              @change="regionSelectChange"
              v-model="formLabelAlign.StoreNameSelect"
            >
              <el-option
                v-for="(item, index) in formLabelAlign.StoreName"
                :key="index"
                :label="item.ShopName"
                :value="item.ShopID"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="待转会员所品牌顾问" prop="AdviserSelect">
            <el-select
              style="width: 100%"
              @change="AdviserSelectChange"
              v-model="formLabelAlign.AdviserSelect"
            >
              <el-option
                v-for="(item, index) in formLabelAlign.Adviser"
                :key="index"
                :label="item.EmpName"
                :value="item.EmpID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ButTransferShop">保 存</el-button>
          <el-button @click="shopFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 会员转品牌顾问弹窗 -->
    <div class="consultant">
      <el-dialog
        width="25%"
        :close-on-click-modal="false"
        title="会员转店\品牌顾问——转店品牌顾问申请"
        :visible.sync="consultantFormVisible"
        @
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="150px"
          :model="TurnBrandConsultant"
          ref="TurnBrandConsultantRef"
          :rules="TurnBrandConsultantRules"
        >
          <el-form-item label="当前品牌顾问">
            <el-input
              v-model="TurnBrandConsultant.serviceEmpName"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="待转会员所品牌顾问" prop="serviceEmpSelect">
            <el-select
              style="width: 100%"
              v-model="TurnBrandConsultant.serviceEmpSelect"
            >
              <el-option
                :label="item.EmpName"
                :value="item.EmpID"
                v-for="(item, index) in TurnBrandConsultant.serviceEmpData"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ConfirmTurnBrandConsultant">保 存</el-button>
          <el-button @click="consultantFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 消费等级调整弹窗 -->
    <div class="consumption">
      <el-dialog
        width="40%"
        :close-on-click-modal="false"
        title="会员消费等级—会员消费等级调整"
        :visible.sync="consumptionFormVisible"
      >
        <div>
          <el-form
            ref="ConsumptionAdjustmentRef"
            style="margin-top: 20px"
            size="mini"
            :label-position="labelPosition"
            label-width="130px"
            :model="ConsumptionAdjustment"
            :rules="ConsumptionAdjustmentRules"
          >
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="会员卡号">
                  <el-input
                    readonly
                    style="width: 100%"
                    v-model="ConsumptionAdjustment.CardNumber"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会员姓名">
                  <el-input
                    readonly
                    style="width: 100%"
                    v-model="ConsumptionAdjustment.Name"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="会员调整前消费等级">
                  <el-input
                    readonly
                    style="width: 100%"
                    v-model="ConsumptionAdjustment.BeforeGrade"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="会员调整后消费等级"
                  prop="AfterGradeSelect"
                >
                  <el-select
                    style="width: 100%"
                    v-model="ConsumptionAdjustment.AfterGradeSelect"
                  >
                    <el-option
                      :label="item.levelName_cn"
                      :value="item.levelID"
                      v-for="(
                        item, index
                      ) in ConsumptionAdjustment.AfterGradeData"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="调整原因" prop="ReansonSelect">
                  <el-select
                    style="width: 100%"
                    v-model="ConsumptionAdjustment.ReansonSelect"
                  >
                    <el-option
                      :label="item.reason_CN"
                      :value="item.reasonID"
                      v-for="(item, index) in ConsumptionAdjustment.ReansonData"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实际变更日期" prop="ChangDate">
                  <el-date-picker
                    style="width: 100%"
                    v-model="ConsumptionAdjustment.ChangDate"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="调整说明" prop="Explain">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="ConsumptionAdjustment.Explain"
                    style="background-color: #ccc"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button
            style="background-color: #b6b388; color: #fff"
            @click="ComfirConsumptionAdjustment"
            >保 存</el-button
          >
          <el-button
            style="background-color: #fff; color: #b6b388"
            @click="consumptionFormVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 冻结弹窗 -->
    <div class="freeze">
      <el-dialog
        width="30%"
        :close-on-click-modal="false"
        title="冻结卡级别-冻结/解冻"
        :visible.sync="freezeFormVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="80px"
          :model="UnfreezeMembers"
        >
          <el-row>
            <el-form-item label="会员姓名">
              <el-input v-model="UnfreezeMembers.Name" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="会员卡号">
              <el-input
                v-model="UnfreezeMembers.CardNumber"
                readonly
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="会员等级">
              <el-input v-model="UnfreezeMembers.Grade" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="移动电话">
              <el-input v-model="UnfreezeMembers.Phone" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="所属区域">
              <el-input v-model="UnfreezeMembers.Region" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="所属门店">
              <el-input v-model="UnfreezeMembers.Store" readonly></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="状态">
              <el-input v-model="UnfreezeMembers.StateName" readonly></el-input>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="UnfreezeMembers.ButText"
              ></el-input>
            </el-form-item>
          </el-row> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComfiUnfreezeMembers">{{
            UnfreezeMembers.ButText
          }}</el-button>
          <el-button @click="freezeFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { mapState } from "vuex";
import {
  UpdateCardNo,
  unbind,
  GetShopQueryRegion,
  GetShopSelectList,
  EmpSelectEmp,
  UpdateService,
  GetSelectList,
  GetDetail,
  CustlvlQuerySelect,
  CustLvlRequestInsert,
  Freezeinsert,
  FreezeThaw,
} from "@/api/viewMemberModule";
export default {
  data() {
    return {
      textarea: "",
      alterationFormVisible: false,
      shopFormVisible: false,
      consultantFormVisible: false,
      consumptionFormVisible: false,
      bindingFormVisible: false,
      freezeFormVisible: false,
      labelPosition: "left",
      formLabelAlignRules: {
        regionSelect: [
          { required: true, message: "请选择目标区域", trigger: "change" },
        ],
        StoreNameSelect: [
          { required: true, message: "请选择目标店铺", trigger: "change" },
        ],
        AdviserSelect: [
          { required: true, message: "请选择待转品牌顾问", trigger: "change" },
        ],
      },
      TurnBrandConsultantRules: {
        serviceEmpSelect: [
          {
            required: true,
            message: "请选择待转会员所品牌顾问",
            trigger: "change",
          },
        ],
      },
      TurnBrandConsultant: {
        serviceEmpSelect: "",
        serviceEmpData: [],
        serviceEmpName: "",
      },
      ConsumptionAdjustmentRules: {
        ReansonSelect: [
          { required: true, message: "请选择调整原因", trigger: "change" },
        ],
        AfterGradeSelect: [
          {
            required: true,
            message: "请选择会员调整后消费等级",
            trigger: "change",
          },
        ],
        ChangDate: [
          {
            type: "date",
            required: true,
            message: "请选择实际变更日期",
            trigger: "change",
          },
        ],
        Explain: [
          { required: true, message: "请输入调整说明", trigger: "blur" },
        ],
      },
      ConsumptionAdjustment: {
        ReansonData: [],
        AfterGradeData: [],
        CardNumber: "",
        BeforeGrade: "",
        ReansonSelect: "",
        AfterGradeSelect: "",
        ChangDate: "",
        Name: "",
        Explain: "",
      },
      formLabelAlign: {
        region: [],
        regionSelect: "",
        StoreName: [],
        StoreNameSelect: "",
        Adviser: [],
        AdviserSelect: "",
      }, //会员转店数据
      cardForm: {
        NewCardNumber: "",
      },
      cardFormRules: {
        NewCardNumber: [
          { required: true, message: "请输入新卡号", trigger: "blur" },
        ],
      },
      UnfreezeMembers: {
        Name: "",
        CardNumber: "",
        Grade: "",
        Phone: "",
        Region: "",
        Store: "",
        StateName: "",
        ButText: "",
      },
      //控制按钮
      showButton: "",
      jurisdiction: {
        level: false,
        relationship: false,
        Unbinding: false,
        frozen: false,
        change: false,
        transfer: false,
        adviser: false,
      },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
      MemberInformation: (state) => state.user.MemberInformation,
    }),
  },
  created() {
    this.SetPageData();
    let LookMember = JSON.parse(localStorage.getItem("LookMember"));
    for (let i = 0; i < LookMember.length; i++) {
      if (LookMember[i].menuName == "消费等级调整") {
        this.jurisdiction.level = true;
        continue;
      }
      if (LookMember[i].menuName == "会员关系绑定") {
        this.jurisdiction.relationship = true;
        continue;
      }
      if (LookMember[i].menuName == "解绑微信") {
        this.jurisdiction.Unbinding = true;
        continue;
      }
      if (LookMember[i].menuName == "冻结/解冻") {
        this.jurisdiction.frozen = true;
        continue;
      }
      if (LookMember[i].menuName == "卡号变更") {
        this.jurisdiction.change = true;
        continue;
      }
      if (LookMember[i].menuName == "会员转店") {
        this.jurisdiction.transfer = true;
        continue;
      }
      if (LookMember[i].menuName == "会员转品牌顾问") {
        this.jurisdiction.adviser = true;
        continue;
      }
    }
  },
  mounted() {},
  methods: {
    Forzen() {
      //冻结/解冻
      this.SetPageData();
      this.freezeFormVisible = true;
    },
    GradeAdjustment() {
      //消费等级调整
      if (this.ConsumptionAdjustment.ReansonData.length <= 0) {
        this.RGetSelectList();
      }
      if (this.ConsumptionAdjustment.AfterGradeData.length <= 0) {
        this.RCustlvlQuerySelect();
      }
      this.ConsumptionAdjustment.CardNumber = this.MemberInformation.cardNo;
      this.ConsumptionAdjustment.Name =
        this.MemberInformation.lastName + this.MemberInformation.firstName;
      this.ConsumptionAdjustment.BeforeGrade =
        this.MemberInformation.levelNameCn;
      this.$nextTick(() => {
        this.consumptionFormVisible = true;
      });
    },
    MemberTransfer() {
      //会员转店
      if (this.formLabelAlign.region.length == 0) {
        this.RGetShopQueryRegion();
      }
      this.$nextTick(() => {
        this.shopFormVisible = true;
      });
    },
    SetPageData() {
      //获取会员信息 组装会员数据
      this.TurnBrandConsultant.serviceEmpName =
        this.MemberInformation.serviceEmpName;
      this.ConsumptionAdjustment.CardNumber = this.MemberInformation.cardNo;
      this.ConsumptionAdjustment.Name =
        this.MemberInformation.lastName + this.MemberInformation.firstName;
      this.ConsumptionAdjustment.BeforeGrade =
        this.MemberInformation.levelNameCn;
      this.UnfreezeMembers.Name =
        this.MemberInformation.lastName + this.MemberInformation.firstName;
      this.UnfreezeMembers.CardNumber = this.MemberInformation.cardNo;
      this.UnfreezeMembers.Grade = this.MemberInformation.levelNameCn;
      this.UnfreezeMembers.Phone = this.MemberInformation.mobile;
      this.UnfreezeMembers.Region = this.MemberInformation.regionName;
      this.UnfreezeMembers.Store = this.MemberInformation.serviceOrgCode;
      if (!this.MemberInformation.freezeState) {
        this.UnfreezeMembers.StateName = "正常";
        this.UnfreezeMembers.ButText = "冻 结";
      } else {
        this.UnfreezeMembers.StateName = "冻结";
        this.UnfreezeMembers.ButText = "解 冻";
      }
      if (
        this.$route.query.showButton === undefined ||
        this.$route.query.showButton === ""
      ) {
        // console.log(this.showButton);
      } else {
        this.showButton = this.$route.query.showButton;
        // console.log(this.showButton);
      }
    },
    ComfiUnfreezeMembers() {
      if (!this.MemberInformation.freezeState) {
        let data = require("qs").stringify({
          cpyNo: getcpyNo(),
          custID: this.custID,
        });
        Freezeinsert(data).then((res) => {
          if (res.success) {
            this.RGetDetail();
            this.$message({
              message: "冻结成功",
              type: "success",
            });
            this.freezeFormVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      } else {
        let data = require("qs").stringify({
          cpyNo: getcpyNo(),
          custID: this.custID,
        });
        FreezeThaw(data).then((res) => {
          if (res.success) {
            this.RGetDetail();
            this.$message({
              message: "解冻成功",
              type: "success",
            });
            this.freezeFormVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      }
    },
    RCustlvlQuerySelect() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo(),
      });
      CustlvlQuerySelect(data).then((res) => {
        if (res.success && res.data.length > 0) {
          this.ConsumptionAdjustment.AfterGradeData = res.data;
        } else {
          this.ConsumptionAdjustment.AfterGradeData = [];
        }
      });
    },
    RGetSelectList() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo(),
        reasonKind: "100",
      });
      GetSelectList(data).then((res) => {
        if (res.success && res.data.length > 0) {
          this.ConsumptionAdjustment.ReansonData = res.data;
        } else {
          this.ConsumptionAdjustment.ReansonData = [];
        }
      });
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    ComfirConsumptionAdjustment() {
      this.$refs.ConsumptionAdjustmentRef.validate((valid) => {
        if (valid) {
          let data = require("qs").stringify({
            cpyNo: getcpyNo(),
            chgReasonID: this.ConsumptionAdjustment.ReansonSelect,
            custID: this.custID,
            origLevel: this.MemberInformation.levelID,
            newLevel: this.ConsumptionAdjustment.AfterGradeSelect,
            realChgDate: this.renderTime(
              this.ConsumptionAdjustment.ChangDate
            ).substring(0, 10),
            remark: this.ConsumptionAdjustment.Explain,
          });
          CustLvlRequestInsert(data).then((res) => {
            if (res.success) {
              this.RGetDetail();
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.consumptionFormVisible = false;
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
          this.consumptionFormVisible = false;
        } else {
          return false;
        }
      });
    },
    RGetDetail() {
      //获取会员基本信息 (用于修改了用户信息后刷新Vuex和本地完成数据更新)
      let data = require("qs").stringify({
        custID: this.custID,
        cpyNo: getcpyNo(),
      });
      GetDetail(data).then((res) => {
        if (res.success == true) {
          res.data.gender =
            res.data.gender == 2 ? "男" : res.data.gender == 1 ? "女" : "未知";
          res.data.isMillVIP = res.data.isMillVIP == 1 ? true : false;
          res.data.custType = res.data.custType == 1 ? true : false;
          if (res.data.yearMaxSaleOrgList.length > 0) {
            let yearMaxSaleOrgList = "";
            res.data.yearMaxSaleOrgList.forEach((item, index) => {
              if (index >= 0 && index <= 2) {
                yearMaxSaleOrgList += item + ";";
              }
              if (index == 3) {
                yearMaxSaleOrgList += "...";
              }
            });
            res.data.yearMaxSaleOrgList = yearMaxSaleOrgList;
          } else {
            res.data.yearMaxSaleOrgList = "";
          }
          this.$store.dispatch("user/UpGetMemberInformation", res.data);
          this.SetPageData();
          localStorage.setItem("MemberInformation", JSON.stringify(res.data));
        } else {
          this.$message.error(res.message);
        }
      });
    },
    REmpSelectEmp() {
      //获取员工数据
      let data = require("qs").stringify({
        cpyNo: getcpyNo(),
        orgID: this.MemberInformation.serviceOrgID,
      });
      EmpSelectEmp(data).then((res) => {
        if (res.success && res.data.length > 0) {
          this.TurnBrandConsultant.serviceEmpData = res.data;
          this.TurnBrandConsultant.serviceEmpName =
            this.MemberInformation.serviceEmpName;
        } else {
          this.TurnBrandConsultant.serviceEmpData = [];
        }
      });
    },
    ConfirmTurnBrandConsultant() {
      //确认 保 存
      this.$refs.TurnBrandConsultantRef.validate((valid) => {
        if (valid) {
          let data = require("qs").stringify({
            cpyNo: getcpyNo(),
            custID: this.custID,
            newServiceOrgID: this.MemberInformation.serviceOrgID,
            newServiceEmpID: this.TurnBrandConsultant.serviceEmpSelect,
          });
          UpdateService(data).then((res) => {
            if (res.success) {
              this.RGetDetail();
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.consultantFormVisible = false;
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    ButTurnBrandConsultant() {
      //会员转品牌顾问
      if (this.TurnBrandConsultant.serviceEmpData.length <= 0) {
        this.REmpSelectEmp();
      }
      this.consultantFormVisible = true;
    },
    AdviserSelectChange(e) {
      //手动选择品牌顾问
      this.formLabelAlign.AdviserSelect = e;
    },
    regionSelectChange(e) {
      //获取店铺对应的品牌顾问
      let data = require("qs").stringify({
        cpyNo: getcpyNo(),
        orgID: e,
      });
      EmpSelectEmp(data).then((res) => {
        if (res.success && res.data.length > 0) {
          this.formLabelAlign.Adviser = res.data;
          this.formLabelAlign.AdviserSelect = res.data[0].EmpID;
          this.AdviserSelectChange(res.data[0].EmpID);
        } else {
          this.formLabelAlign.Adviser = [];
          this.formLabelAlign.AdviserSelect = "";
        }
      });
    },
    RGetShopSelectList(e) {
      //获取区域对应的店铺数据
      let data = require("qs").stringify({
        cpyNo: getcpyNo(),
        regionID: e,
      });
      GetShopSelectList(data).then((res) => {
        if (res.success && res.data.length > 0) {
          this.formLabelAlign.StoreName = res.data;
          this.formLabelAlign.StoreNameSelect = res.data[0].ShopID;
          this.regionSelectChange(res.data[0].ShopID);
        } else {
          this.formLabelAlign.StoreName = [];
          this.formLabelAlign.StoreNameSelect = "";
        }
      });
    },
    ButTransferShop() {
      //确认转品牌顾问
      this.$refs.ButTransferShopRefs.validate((valid) => {
        if (valid) {
          let that = this;
          let data = require("qs").stringify({
            custID: that.custID,
            newServiceEmpID: that.formLabelAlign.AdviserSelect,
            newServiceOrgID: that.formLabelAlign.StoreNameSelect,
          });
          UpdateService(data).then((res) => {
            if (res.success) {
              this.RGetDetail();
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.shopFormVisible = false;
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
          this.shopFormVisible = false;
        } else {
          return false;
        }
      });
    },
    RGetShopQueryRegion() {
      //获取区域数据
      let data = require("qs").stringify({
        cpyNo: getcpyNo(),
      });
      GetShopQueryRegion(data).then((res) => {
        if (res.success && res.data.length > 0) {
          this.formLabelAlign.region = res.data;
          this.formLabelAlign.regionSelect = res.data[0].id;
          this.RGetShopSelectList(res.data[0].id);
        } else {
          this.formLabelAlign.region = [];
          this.formLabelAlign.regionSelect = "";
        }
      });
    },
    CardNumberChange() {
      this.$refs.CardNumberChanges.validate((valid) => {
        if (valid) {
          let data = require("qs").stringify({
            cpyNo: getcpyNo(),
            newCardNo: this.cardForm.NewCardNumber,
            custID: this.cardForm.custID,
          });
          UpdateCardNo(data).then((res) => {
            if (res.success) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.RGetDetail();
              this.alterationFormVisible = false;
            } else {
              this.$message({
                message: "修改失败,请重试",
                type: "warning",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    UnbindingBin() {
      this.$confirm("确认解绑微信？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        unbind({
          custID: this.custID,
        }).then((res) => {
          if (res.success) {
            this.$message({
              message: "解绑微信成功",
              type: "success",
            });
            this.RGetDetail();
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      });
    },
    CardUpdate() {
      //卡号变更
      this.cardForm = {
        UserName:
          this.MemberInformation.lastName + this.MemberInformation.firstName,
        Phpone: this.MemberInformation.mobile,
        Grade: this.MemberInformation.levelNameCn,
        OldCardNumber: this.MemberInformation.cardNo,
        NewCardNumber: "",
        custID: this.custID,
      };
      this.alterationFormVisible = true;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    goToMembershipBinding() {
      //会员关系绑定
      this.$router.push("/MembershipBinding");
    },
    // 点击返回按钮  返回上一页面
    backHistory() {
      // this.$router.go(-1); //返回上一层
      this.$router.push("/InForMations");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  height: 20px;
  margin-top: 5px;
  color: #76734f;
  font-size: xx-small;
}
.push-button {
  background-color: #e9e7d3;
}

/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 卡号变更弹框样式
  .alteration {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  // 会员转店弹窗样式
  .shop {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .amend .el-form-item__label {
      color: #6c6937;
    }

    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  // 会员转品牌顾问
  .consultant {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  //等级调整弹窗
  .consumption {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }

  // 冻结/解冻弹窗
  .freeze {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
